/**
 * helpers/auth.ts — small storage helpers for the refresh token.
 *
 * v1 trade-off: refresh tokens live in `localStorage` so the user stays
 * signed in across reloads. The access token + per-session secretKey live
 * in redux memory only. A real production deploy SHOULD switch refresh to
 * an httpOnly cookie set by the API — see CLAUDE.md "Auth model". The
 * trade-off is that XSS on this app's origin would expose the refresh
 * token; we accept that for v1.
 */

const REFRESH_KEY = 'ucb.refreshToken';

export function saveRefreshToken(token: string | null): void {
	try {
		if (token) {
			window.localStorage.setItem(REFRESH_KEY, token);
		} else {
			window.localStorage.removeItem(REFRESH_KEY);
		}
	} catch {
		// SSR / privacy mode / quota error — silent fallback. The user will
		// be asked to log in again on next reload, which is acceptable.
	}
}

export function loadRefreshToken(): string | null {
	try {
		return window.localStorage.getItem(REFRESH_KEY);
	} catch {
		return null;
	}
}

export function clearRefreshToken(): void {
	saveRefreshToken(null);
}
